(function() {
    'use strict';

    angular.module('caffeprint')
        .directive('cpInputTextReadonly', cpInputTextReadonly);

    cpInputTextReadonly.$inject = [];

    function cpInputTextReadonly() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'app/caffeprint/directives/input-text-readonly/input-text-readonly.html',
            scope: {
                title: '@',
                labelClass: '@?',
                containerClass: '@',
                prop: '@',
                value: '='
            },
            link: function(scope, element, attrs, controller) {
                scope.getLabelClass = getLabelClass;
                scope.getContainerClass = getContainerClass;

                function isWithLabel() {
                    return scope.labelClass === undefined ? true : false;
                }

                function getLabelClass() {
                    if (scope.labelClass) {
                        return scope.labelClass;
                    } else {
                        return isWithLabel() ? 'col-sm-2' : '';
                    }
                }

                function getContainerClass() {
                    if (scope.containerClass) {
                        return scope.containerClass;
                    } else {
                        return isWithLabel() ? 'col-sm-10' : 'col-sm-12';
                    }
                }
            }
        };
    }
})();
